import { Controller } from 'stimulus'
import { submitContactForm } from 'shared/assets/javascript/contact_form_7'

export default class extends Controller {

  connect() {
    this.formTarget = this.element.querySelector('form')
    this.emailInput = this.element.querySelector('#email_address')
    this.submitButton = this.element.querySelector('.submit')
    this.errorMessage = this.element.querySelector('.form__message--error')
    this.floatingLabel = this.element.querySelector('.floating-label-custom')
    this.originalButtonText = this.submitButton?.textContent || 'SUBSCRIBE'

    if (this.emailInput) {
      this.emailInput.setAttribute('aria-required', 'true')
      this.emailInput.setAttribute('aria-describedby', 'email-address-error')
    }

    this.bindFloatingLabel()
    this.bindInputValidation()
  }

  bindFloatingLabel() {
    if (!this.emailInput || !this.floatingLabel) return

    this.handleFocus = () => this.floatLabel()
    this.handleBlur = () => {
      if (!this.emailInput.value.trim()) {
        this.unfloatLabel()
      }
    }
    this.emailInput.addEventListener('focus', this.handleFocus)
    this.emailInput.addEventListener('blur', this.handleBlur)
  }

  floatLabel() {
    this.floatingLabel.classList.remove('typo-body')
    this.floatingLabel.classList.add('typo-caption', '-float')
  }

  unfloatLabel() {
    this.floatingLabel.classList.remove('typo-caption', '-float')
    this.floatingLabel.classList.add('typo-body')
  }

  bindInputValidation() {
    if (!this.emailInput) return

    this.handleInput = () => {
      // Keep label floated while there's text
      if (this.emailInput.value.trim()) {
        this.floatLabel()
      }
      // Clear error on any input change
      if (this.hasError) {
        this.clearError()
      }
    }
    this.emailInput.addEventListener('input', this.handleInput)
  }

  showError() {
    this.hasError = true
    this.emailInput.classList.add('-error')
    this.emailInput.setAttribute('aria-invalid', 'true')
    this.errorMessage.classList.add('active')
  }

  clearError() {
    this.hasError = false
    this.emailInput.classList.remove('-error')
    this.emailInput.setAttribute('aria-invalid', 'false')
    this.errorMessage.classList.remove('active')
  }

  showSuccess() {
    clearTimeout(this.successTimeout)
    this.submitButton.textContent = 'THANK YOU'
    this.submitButton.disabled = true
    this.submitButton.setAttribute('aria-label', 'Subscription successful')
    this.successTimeout = setTimeout(() => {
      this.submitButton.textContent = this.originalButtonText
      this.submitButton.disabled = false
      this.submitButton.setAttribute('aria-label', 'Subscribe')
      this.emailInput.value = ''
      this.unfloatLabel()
    }, 5000)
  }

  async submit(e) {
    e.preventDefault()

    if (this.isSubmitting) return

    // Validate before submitting
    if (!this.emailInput.value.trim() || !this.emailInput.checkValidity()) {
      this.showError()
      return
    }

    this.isSubmitting = true
    this.submitButton.disabled = true
    this.clearError()
    try {
      let formData = new FormData(this.formTarget)
      let response = await submitContactForm(formData)
      if (response?.status === 'mail_sent') this.showSuccess()
    } finally {
      this.isSubmitting = false
      if (this.submitButton.textContent !== 'THANK YOU') {
        this.submitButton.disabled = false
      }
    }
  }

  disconnect() {
    clearTimeout(this.successTimeout)
    if (this.emailInput) {
      this.emailInput.removeEventListener('focus', this.handleFocus)
      this.emailInput.removeEventListener('blur', this.handleBlur)
      this.emailInput.removeEventListener('input', this.handleInput)
    }
  }

}
